import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import axios from 'axios'
import './AIImproveButton.css'

const API_URL = process.env.REACT_APP_API_URL

function SparkleIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z" />
    </svg>
  )
}

function getAuthHeaders() {
  try {
    const data = JSON.parse(localStorage.getItem('resumeData') || '{}')
    if (data.psw) return { psw: data.psw }
    if (data.token) return { authorization: data.token }
  } catch (e) {
    // ignore
  }
  return {}
}

function getHash() {
  try {
    const data = JSON.parse(localStorage.getItem('resumeData') || '{}')
    return data.hash || null
  } catch (e) {
    return null
  }
}

export default function AIImproveButton({ value, section, onAccept }) {
  const [loading, setLoading] = useState(false)
  const [improvedText, setImprovedText] = useState(null)
  const [error, setError] = useState(null)
  const [open, setOpen] = useState(false)

  const handleClick = async () => {
    const hash = getHash()
    if (!hash) return

    const plainText = value
      ? value.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
      : ''

    if (!plainText) return

    setLoading(true)
    setError(null)

    try {
      const headers = getAuthHeaders()
      const response = await axios.post(
        `${API_URL}/resume/${hash}/ai/improve`,
        { text: value, section },
        { headers }
      )
      setImprovedText(response.data.improvedText)
      setOpen(true)
    } catch (err) {
      const msg =
        err.response?.data?.error || 'Something went wrong. Please try again.'
      setError(msg)
      setOpen(true)
    } finally {
      setLoading(false)
    }
  }

  const handleUse = () => {
    if (improvedText) onAccept(improvedText)
    handleClose()
  }

  const handleClose = () => {
    setOpen(false)
    setImprovedText(null)
    setError(null)
  }

  return (
    <>
      <button
        className="ai-improve-btn"
        onClick={handleClick}
        disabled={loading}
        type="button"
        title="Improve this text with AI"
      >
        <SparkleIcon />
        <span style={{paddingTop: "3px"}}>{loading ? 'Improving...' : 'Improve with AI'}</span>
      </button>

      {open &&
        ReactDOM.createPortal(
          <div className="ai-modal-overlay" onClick={handleClose}>
            <div className="ai-modal" onClick={e => e.stopPropagation()}>
              <div className="ai-modal-header">
                <h3>AI Suggestion</h3>
                <button className="ai-modal-close" onClick={handleClose} type="button">
                  &times;
                </button>
              </div>
              <div className="ai-modal-body">
                {error ? (
                  <div className="ai-modal-error">{error}</div>
                ) : (
                  <>
                    <div className="ai-modal-label">Improved version</div>
                    <div
                      className="ai-modal-preview"
                      dangerouslySetInnerHTML={{ __html: improvedText }}
                    />
                  </>
                )}
              </div>
              {!error && (
                <div className="ai-modal-footer">
                  <button className="ai-btn-discard" onClick={handleClose} type="button">
                    Discard
                  </button>
                  <button className="ai-btn-use" onClick={handleUse} type="button">
                    Use this
                  </button>
                </div>
              )}
              {error && (
                <div className="ai-modal-footer">
                  <button className="ai-btn-discard" onClick={handleClose} type="button">
                    Close
                  </button>
                </div>
              )}
            </div>
          </div>,
          document.body
        )}
    </>
  )
}
